import { useMutation } from 'react-query'

import { languagesService } from 'src/services/languages.service'
import { IUpdateMissingTranslationsDto } from 'src/types'

export const useUpdateMissingTranslations = () => {
  return useMutation((dto: IUpdateMissingTranslationsDto) =>{
    return languagesService.updateMissingTranslationsToAI(dto)
  }
    ,
  )
}
